import { fmt } from "@/lib/api";
import { Check } from "lucide-react";

export const PartnerPackage = ({ pkg, partner, copy, selected, onSelect }) => {
  const includes = [...copy.essential_includes, ...copy.complete_includes, ...copy.signature_includes];
  const isSel = selected === "partner";
  return (
    <div className="max-w-3xl mx-auto" data-testid="partner-package">
      <div className={`bg-white border-2 ${isSel ? "border-black" : "border-[#c19a6b]"} shadow-[0_18px_50px_rgba(193,154,107,0.22)] relative`}>
        <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#c19a6b] text-white text-[10px] tracking-[0.25em] uppercase font-bold py-1.5 px-4 whitespace-nowrap">
          Your {partner.realtor_name} Client Benefit
        </div>

        <div className="p-8 sm:p-12 pt-12">
          <div className="text-center">
            <p className="text-[11px] uppercase tracking-[0.2em] text-gray-400">ARK Furniture</p>
            <h3 className="font-display text-3xl sm:text-4xl mt-2">Signature Revival</h3>
            <p className="text-sm text-gray-500 mt-4 max-w-md mx-auto leading-relaxed">{copy.signature_tagline}</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-14 mt-10">
            <div className="text-center">
              <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">Regular Signature price</p>
              <p className="font-display text-3xl text-gray-400 line-through decoration-[#c19a6b]/70 mt-2" data-testid="partner-retail-price">
                {fmt(pkg.retail_subtotal_cents)}
              </p>
            </div>
            <div className="text-center">
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#8a6a42]">Your {partner.realtor_first_name || partner.realtor_name} client rate</p>
              <p className="font-display text-5xl text-[#c19a6b] mt-2" data-testid="partner-client-price">{fmt(pkg.subtotal_cents)}</p>
              <p className="text-xs text-gray-400 mt-1">+ HST</p>
            </div>
          </div>

          <div className="bg-[#FAF7F2] border border-[#c19a6b]/30 py-5 px-6 mt-10 text-center" data-testid="partner-savings">
            <p className="text-[10px] uppercase tracking-[0.22em] text-[#8a6a42]">
              Your {partner.realtor_name} client benefit saves you
            </p>
            <p className="font-display text-3xl text-[#c19a6b] mt-2">{fmt(pkg.savings_cents)}</p>
          </div>

          <p className="text-[11px] uppercase tracking-[0.18em] text-[#c19a6b] font-bold mt-12 mb-5 text-center">
            Everything included in your Signature Revival
          </p>
          <div className="grid sm:grid-cols-2 gap-x-10">
            {includes.map((inc, i) => (
              <div key={i} className="flex gap-2.5 py-2.5 border-b border-gray-100">
                <Check size={15} className="text-[#c19a6b] shrink-0 mt-0.5" />
                <span className="text-sm text-gray-700 leading-snug">{inc}</span>
              </div>
            ))}
          </div>

          <button
            data-testid="select-partner-package"
            onClick={() => onSelect("partner")}
            className={`mt-10 w-full h-14 text-xs uppercase tracking-[0.2em] font-bold btn-lift ${
              isSel ? "bg-black text-white" : "bg-[#c19a6b] text-white hover:bg-[#b08a5c]"
            }`}
          >
            {isSel ? "Selected" : "Choose My Signature Revival"}
          </button>
        </div>
      </div>
      <p className="text-center text-xs text-gray-400 mt-6 leading-relaxed max-w-lg mx-auto">
        This is our full Signature Revival service — the private client rate simply changes what you pay, never what
        you receive.
      </p>
    </div>
  );
};
